// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_2BaEJYulOrH2_i6ZYf-DdV","largeAvatar":"_2okbOWdCbmllM9MQ_sYDVd _2BaEJYulOrH2_i6ZYf-DdV"};